<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />
    <b-modal
      :no-close-on-backdrop="true"
      :id="`modal-confirm-print`"
      :title="$t('surgery.print-invoice')"
      ok-only
      :ok-title="$t('common.print')"
      @ok="printIvfIncome"
    >
      <b-card-text>
        <h5>{{ $t("surgery.print-invoice") }}</h5>
        {{ $t("surgery.print-sure") }}
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode ? $t('surgery.Create-Income') : $t('surgery.Edit-Income')
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <b-form-group :label="$t('common.name')" label-for="name">
              <b-form-input
                v-model="EditForm.name"
                :placeholder="$t('common.name')"
              />
              <p class="text-danger mt-1">{{ errorForm.name }}</p>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col md="">
            <b-form-checkbox
              id="checkbox-1"
              v-model="currency"
              name="checkbox-1"
              value="USD"
              unchecked-value="IQD"
            >
              {{ $t("common.is-dollar") }}
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="currency === 'USD'">
          <b-col md="">
            <b-form-group :label="$t('common.Amount-USD')" label-for="USD">
              <b-form-input
                type="number"
                v-model="EditForm.amount_usd"
                :placeholder="$t('common.Amount-USD')"
              />
              <p class="text-danger mt-1">{{ errorForm.amount_usd }}</p>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group :label="$t('common.Amount-IQD')" label-for="name">
              {{ formatIQDCurrency(EditForm.amount_usd * exchangeRate) }}
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col md="">
            <b-form-group :label="$t('common.Amount-IQD')" label-for="name">
              <b-form-input
                type="number"
                v-model="EditForm.amount_iqd"
                :placeholder="$t('common.Amount-IQD')"
              />
              <p class="text-danger mt-1">{{ errorForm.amount_iqd }}</p>
            </b-form-group>
          </b-col>

          <b-col md="">
            <b-form-group :label="$t('common.Amount-USD')" label-for="name">
              <b-col>
                {{ formatUSDCurrency(EditForm.amount_iqd / exchangeRate) }}
              </b-col>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="">
            <b-form-group :label="$t('common.Date')" label-for="date">
              <datepicker
                v-model="EditForm.date"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              ></datepicker>
              <p class="text-danger mt-1">{{ errorForm.date }}</p>
            </b-form-group>
          </b-col>
          <b-col md="">
            <b-form-group
              :label="$t('common.Exchange-Rate')"
              label-for="Description"
            >
              <b-form-input
                v-model="exchangeRate"
                :readonly="true"
                :diabled="true"
                :placeholder="$t('common.Exchange-Rate')"
                type="number"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="">
            <b-form-group
              :label="$t('common.description')"
              label-for="Description"
            >
              <b-form-textarea
                v-model="EditForm.description"
                :placeholder="$t('common.description')"
                type="textarea"
              />
              <p class="text-danger mt-1">{{ errorForm.description }}</p>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t("common.add") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>

    <b-card :title="$t('surgery.ivf-income')">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("surgery.Filter-Income") }}</h2>
            <br />
          </b-col>

          <b-col md="4" cols="6">
            <b-form-group :label="$t('common.from-date')" label-for="date">
              <b-form-datepicker
                id="example-datepicker"
                v-model="fromDate"
                class="mb-2"
                today-button
                reset-button
                close-button
              ></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col md="4" cols="6">
            <b-form-group :label="$t('common.to-date')" label-for="date">
              <b-form-datepicker
                id="example-datepicker2"
                v-model="toDate"
                class="mb-2"
                today-button
                reset-button
                close-button
              ></b-form-datepicker>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-2 mt-1">
          <b-col md="4" cols="6">
            <b-form-group :label="$t('common.amount-iqd-sum')" label-for="name">
              <h3>
                <b-badge variant="primary">{{
                  formatIQDCurrency(sums.amount_iqd_sum)
                }}</b-badge>
              </h3>
            </b-form-group>
          </b-col>
          <b-col md="4" cols="6">
            <b-form-group :label="$t('common.amount-usd-sum')" label-for="name">
              <h3>
                <b-badge variant="primary">{{
                  formatUSDCurrency(sums.amount_usd_sum)
                }}</b-badge>
              </h3>
            </b-form-group>
          </b-col>
          <b-col md="4" cols="12">
            <br />
          </b-col>
          <b-col md="4" cols="6">
            <p class="text-muted font-weight-bold">
              {{ $t("common.this-sums-based-on-the-selected-date") }}
            </p>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getIVFIncomeList()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("surgery.ivf-income") }}</h2>
          <b-button
            variant="primary"
            @click="show(EditForm, 'create')"
            v-if="$store.state.app.permissions.includes('store-ivfIncome')"
          >
            {{ $t("surgery.Create-Income") }}
          </b-button>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="columns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(amount_iqd)="data">
            <span class="text-nowrap font-weight-bolder">
              {{ formatIQDCurrency(data.item.amount_iqd) }}
            </span>
          </template>
          <template #cell(amount_usd)="data">
            <span class="text-nowrap font-weight-bolder">
              {{ formatUSDCurrency(data.item.amount_usd) }}
            </span>
          </template>

          <template #cell(currency_ex_rate)="data">
            <span class="text-nowrap">
              {{ data.item.currency_ex_rate }}
            </span>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap d-flex">
              <b-button
                @click="showPrintIvfIncome(data.item)"
                variant="outline-primary"
                pill
                size="sm"
                class="mx-1"
                >{{ $t("common.print") }}</b-button
              >
              <OutsideReceipt :data="ivfIncomeData" />
              <b-button
                ref="ivfIncomeRef"
                v-print="OutsideReceipt"
                variant="outline-primary"
                pill
                size="sm"
                class="mx-1 hidden"
                >{{ $t("common.print") }}</b-button
              >
              <ActionsButtons
                deletePerm="delete-ivfIncome"
                editPerm="update-ivfIncome"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing 1 to 10 IVF Items</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getIVFIncomeList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BFormCheckbox,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BBadge,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import Datepicker from "vuejs-datepicker";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import OutsideReceipt from "@/components/printables/OutsideReceipt.vue";

export default {
  components: {
    DeleteModal,
    BFormCheckbox,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    Datepicker,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    OutsideReceipt,
    BBadge,
  },
  data() {
    return {
      take: 1000,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      doctorDataCount: 0,
      data: [],
      doctorData: [],
      EditForm: {
        amount_iqd: "",
        amount_usd: "",
        description: "",
        date: "",
        currency_ex_rate: 0,
        _method: "PUT",
        name: "ahmed",
      },
      createMode: false,
      errorForm: {
        amount_iqd: "",
        amount_usd: "",
        description: "",
        date: "",
      },
      params: {
        form: {},
        path: "",
      },
      columns: [
        {
          key: "name",
          sortable: true,
          label: this.$t("common.name"),
        },
        {
          key: "amount_iqd",
          sortable: true,
          label: this.$t("common.Amount-IQD"),
        },
        {
          key: "amount_usd",
          sortable: true,
          label: this.$t("common.Amount-USD"),
        },
        {
          key: "description",
          sortable: true,
          label: this.$t("common.description"),
        },
        {
          key: "currency_ex_rate",
          sortable: true,
          label: this.$t("common.Exchange-Rate"),
        },

        {
          key: "date",
          sortable: true,
          label: this.$t("common.Date"),
          thStyle: { width: "150px" },
        },
        // { key: "created_at", sortable: true, label: this.$t("common.created_at") },
        { key: "Actions", label: this.$t("common.actions") },
      ],

      exchangeRate: 0,
      currency: "USD",
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      expenses: "IVF Expenses",
      OutsideReceipt: {
        id: "outsideReceipt",
      },

      DoctorList: [],
      sums: {
        amount_iqd_sum: 0,
        amount_usd_sum: 0,
      },
      toDate: "",
      fromDate: "",
      ivfIncomeData: {},
    };
  },
  mounted() {
    const today = new Date();
    this.fromDate = `${today.getFullYear()}-${String(
      today.getMonth() + 1
    ).padStart(2, "0")}-01`;
    this.getIVFIncomeList();
    this.getIvfExchangeRate();
  },
  methods: {
    showPrintIvfIncome(data) {
      this.ivfIncomeData = data;
      this.$bvModal.show("modal-confirm-print");
    },
    printIvfIncome() {
      console.log("ivfIncomeData", this.ivfIncomeData);
      this.$refs.ivfIncomeRef.click();
    },
    formatDate(ivfDate) {
      const date = new Date(ivfDate);
      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1);
      let day = "" + date.getDate();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return `${year}-${month}-${day}`;
    },
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          amount_iqd: "",
          amount_usd: "",
          description: "",
          date: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;
        this.EditForm.name = item.name;
        this.EditForm.id = item.id;
        this.EditForm.amount_iqd = item.amount_iqd;
        this.EditForm.amount_usd = item.amount_usd;
        this.EditForm.description = item.description;
        this.EditForm.date = item.date;
        if (this.expenses == "Doctors Expenses") {
          this.EditForm.doctor_id = item.doctor_id;
        }

        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    async getIVFIncomeList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/ivfIncome?page=${this.page}&take=${
        this.fromDate ? 1000 : 100
      }&sort=-id`;

      if (this.fromDate) {
        url += `&filter[date-ge]=${this.fromDate}`;
      }
      if (this.toDate) {
        url += `&filter[date-le]=${this.toDate}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.pagination.total;
      this.sums.amount_iqd_sum = this.all_data.sums.amount_iqd_sum;
      this.sums.amount_usd_sum = this.all_data.sums.amount_usd_sum;
      this.data = this.all_data.data;
      this.loading = false;
    },

    async getIvfExchangeRate() {
      this.loading = true;

      let url = `/ivfExchangeRate?&sort=-created_at`;

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.exchangeRate = this.all_data.data[0].value;
      this.loading = false;
    },
    formatIQDCurrency(value) {
      // Create a new Intl.NumberFormat object for IQD currency
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "IQD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });

      // Format the value and return it
      return formatter.format(value);
    },
    formatUSDCurrency(value) {
      // Ensure the value is a number and format it to one decimal place
      const formattedValue = Number(value).toFixed(1);

      // Create a new Intl.NumberFormat object for USD currency without cents
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });

      // Format the value and return it
      return formatter.format(formattedValue);
    },

    deleteModel(item) {
      this.deleteForm = item;
      console.log("deleteForm", this.deleteForm);
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/ivfIncome/${this.deleteForm.id}`)
        .then((response) => {
          this.getIVFIncomeList();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },

    submitItem() {
      let count = 0;
      this.loading = true;
      this.errorForm.amount_iqd = "";
      this.errorForm.amount_usd = "";
      this.errorForm.description = "";
      this.errorForm.date = "";
      this.errorForm.name = "";
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (!this.EditForm.amount_iqd && this.currency === "IQD") {
        count++;
        this.errorForm.amount_iqd = "The amount IQD field is required.";
      }
      if (!this.EditForm.amount_usd && this.currency === "USD") {
        count++;
        this.errorForm.amount_usd = "The amount USD field is required.";
      }
      if (!this.EditForm.description) {
        count++;
        this.errorForm.description = "The description field is required.";
      }
      if (!this.EditForm.date) {
        count++;
        this.errorForm.date = "The date field is required.";
      }

      if (!this.EditForm.name) {
        count++;
        this.errorForm.name = "The name field is required.";
      }
      console.log("editForm", this.EditForm);
      if (count > 0) {
        this.loading = false;
        return false;
      }

      if (this.currency === "USD") {
        this.EditForm.amount_iqd = this.EditForm.amount_usd * this.exchangeRate;
      }

      if (this.currency === "IQD") {
        this.EditForm.amount_usd = this.EditForm.amount_iqd / this.exchangeRate;
      }

      this.EditForm.date = this.formatDate(this.EditForm.date);
      this.EditForm.currency_ex_rate = this.exchangeRate;
      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/ivfIncome`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.loading = false;
              this.$bvModal.hide("modal-edit");
              console.log("this.expenses", this.expenses);

              this.getIVFIncomeList();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                this.loading = false;
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/ivfIncome/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.loading = false;
              this.$bvModal.hide("modal-edit");
              this.getIVFIncomeList();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                this.loading = false;
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
